<template>
	<div class='homework'>
		<template v-if="homeworData.length > 0">
			<div class="homework-title">
				{{homeTitle}}
			</div>
			<el-tabs v-model="activeName" @tab-click="handleClick"  class="homework-tabs" >
				<el-tab-pane v-for="itemOne in homeworData" :key="itemOne.name" :label="itemOne.name | format" :name="itemOne.name" >
					<div class="homework-slogan"><span v-html="itemOne.answer"></span> <em v-html="itemOne.prompt"></em></div>
					<FormSelection v-for="(prop, index) in curHomework.children" :key="prop.questionId" :index="index+1" :questionObj='prop' @example='example' />
				</el-tab-pane>
			</el-tabs>

			<div label-width="auto" class="homework-btn">
				<el-button type="primary" @click="onSubmit" round :disabled="isBtn">保存</el-button>
			</div>
		</template>
		<template v-else>
			<div  class="homework-empty">
				<img src="../../../assets/images/homework/homework-empty.png" alt="">
			</div>
		</template>
		<el-dialog :title="dialog" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
			<img :src="dialogImgUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ImageUpload from '../../component/ImageUpload'
import HomeworkApi from '@/api/homework.api'
import FormSelection from './components/FormSelection'
export default {
	name:'homework',
	components: {
		FormSelection,
	},
	data() {
		return {
			activeName: '1',
			homeTitle: '',
			qid: '',
			homeworData: [],
			dialogVisible: false,
			dialog: '',
			dialogImgUrl:'',
			isBtn:false
		}
	},
	filters: {
		format(val) {
			const digital = ['一','二','三','四','五','六','七','八','九','十']
			return `第${digital[val - 1]}课`
		}

	},
	computed: {
		...mapGetters('user', ['userInfo']),
		curHomework() {//根据课程显示对应题目
			return this.homeworData.find(work => this.activeName === work.name) || {}
		}
	},
	created() {
		this.homeworTitle()
		this.homeworkInfo()
	},
	watch: {},
	methods: {
		handleClick(tab, event) {
			console.log(tab, event)
		},
		async homeworTitle(){
			let params = {}
			const id = this.$route.query.qid
			if(id) params.qid = id
			let {data} = await HomeworkApi.getCourseQuick(params)
			if(data.isSuccess){
				if(!data.data) return
				this.qid = data.data.qid
				this.homeTitle = data.data.title
			}else{
				console.log(data.message)
			}

		},
		async onSubmit() {
			this.isBtn = true
			const questionList = this.curHomework.children.reduce((newArr, prop) => {
				newArr = [...newArr, ...prop.questionList]
				return newArr
			}, [])
			const params = questionList.reduce((newArr, prop) => {
				let paramsObj = {}
				paramsObj.questionId = prop.questionId
				paramsObj.answerId = prop.answerId
				paramsObj.answerInfo = prop.answerInfo
				paramsObj.uid = this.userInfo.uid
				paramsObj.qid = this.$route.query.qid || this.qid
				newArr.push(paramsObj)
				return newArr
			}, [])
			const { data } = await HomeworkApi.saveAnswer(params)
			if(data.isSuccess){

				this.isBtn = false
				this.$message({
					message: '作业提交成功！',
					type: 'success',
					offset:350
				})
			}else{
				this.$message.error('作业提交失败！')
			}
		},
		example(val){

			this.dialog = val.examplesUrlTitle
			this.dialogImgUrl = val.examplesUrl
			this.dialogVisible = true
		},
		async homeworkInfo(){
			const params = {
				uid : this.userInfo.uid
			}
			const id = this.$route.query.qid
			if(id){
				params.qid = id
			}
			let { data } = await HomeworkApi.questionInfo(params)
			if(data.isSuccess){
				if(!data.data) return
				this.homeworData = this.compare(data.data)
			}else{
				console.log(data.message)
			}
		},
		compare(val){
			val.forEach( i => {
				if(i.children.length < 2){ return }
				i.children = this.quickSort(i.children)
			})
			return  val
		},
		quickSort(arr) {
			if (arr.length < 2 ) { return arr }
			const pivot = arr[0]
			const left = []
			const right = []
			if (arr.length < 2) { return arr }
			for (let i = 1, len = arr.length; i < len; i++) {
				arr[i].subjectSort < pivot.subjectSort ? left.push(arr[i]) : right.push(arr[i])
			}
			return this.quickSort(left).concat([pivot], this.quickSort(right))
		},
		handleClose() {
			this.dialog = ''
			this.dialogImgUrl = ''
			this.dialogVisible = false
		}

	},
}
</script>
<style lang='scss' scoped>
.homework{
	min-height: 100%;
	padding: 40px 20px;
	border-radius: 4px;
	background-color: #fff;
	display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.homework-title{
	width: 100%;
	height: 90px;
	font-size: 40px;
	line-height: 90px;
	text-align: center;
	color: #161616;
}
.homework-tabs{
	width: 100%;
	margin-bottom: 40px;
	.el-tabs__nav-wrap::after{
		height: 1px;
		background-color: #edebeb;
	}
}
.homework-slogan{
	height: 40px;
	position: relative;
	padding-left:130px ;
	margin-bottom: 20px;
	background-color: #f7f9fc;
	border: solid 1px #eeeeee;
	font-size:18px ;
	line-height: 40px;
	letter-spacing: 2px;
	color: #ff6600;
	span{
		position: absolute;
		top:0;
		left: 0;
		width: 86px;
		height: 40px;
		background-color: #ff6600;
		text-align: center;
		color: #fff;
		&:after{
			content: "";
			position: absolute;
			top: 0;
			right: -20px;
			width: 0;
			height: 0;
			border-style: solid;
			border-width: 20px 0 20px 20px;
			border-color: transparent transparent transparent #ff6600;
		}
	}

}

.homework-item{
	border: solid 1px #dedede;
	padding-bottom: 36px;
	margin-bottom: 19px;
	margin-left:10px ;
	textarea{
		border: 0;
	}

}
.homework-item-title{
	position: relative;
	height: 60px;
	padding-left:60px;
	border-bottom: solid 1px #dedede;
	font-size: 18px;
	line-height: 60px;
	color: #000000;
	span{
		display: block;
		position: absolute;
		top: 9px;
		left:-12px ;
		width: 58px;
		height: 44px;
		background: url(../../../assets/images/homework/homework-icon1.png) no-repeat left bottom;
		font-size:26px;
		font-family: arial;
		font-style: italic;
		color: #fff;
		text-align: center;
		line-height: 38px;
	}
	i{
		color: #367BF6;
		margin-left: 8px;
		cursor: pointer;
	}
}

.homework-int2,.homework-int3{
	.homework-item-txt{
		position: absolute;
		top: 15px;
		left: 0;
		font-size: 16px;
		font-weight: bold;
		line-height: 20px;
		color: #666666;
		z-index: 99;
	}
	.homework-icon{
		display: block;
		position: absolute;
		top: 13px;
		left: -14px;
		z-index: 99;
		width: 24px;
		height: 24px;
		background-color: #868484;
		border-radius: 0px 12px 0px 12px;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		color: #fff;
	}
	.el-form-item{
		padding: 0 14px;
		margin-bottom: 16px;
	}
}
.homework-btn{
	margin-top: 20px;
	margin-left: 20px;
	button{
		padding:12px 38px;
	}
}
.homework-img{
	height: 259px;
}
.el-dialog{
	img{
		display: block;
		max-width: 100%;
		margin: 0 auto;
	}
}
.homework-empty{
	min-height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
